import { render, staticRenderFns } from "./portrait.vue?vue&type=template&id=13f1ae2e&scoped=true&"
import script from "./portrait.vue?vue&type=script&lang=ts&"
export * from "./portrait.vue?vue&type=script&lang=ts&"
import style0 from "./portrait.vue?vue&type=style&index=0&id=13f1ae2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1ae2e",
  null
  
)

export default component.exports